import { render, staticRenderFns } from "./register.vue?vue&type=template&id=caa63130&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa63130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caa63130')) {
      api.createRecord('caa63130', component.options)
    } else {
      api.reload('caa63130', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=caa63130&scoped=true&", function () {
      api.rerender('caa63130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/register/register.vue"
export default component.exports